import { cx } from "shared/utils";

export const MultiselectPreview = ({
  options,
  selected,
  onToggle
}: {
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
}) => {
  return (
    <div className="flex flex-col gap-2 w-full">
      {options.map((opt) => {
        const isChecked = selected.includes(opt);
        return (
          <label
            key={opt}
            className={cx(
              "bg-content-1000-inverted block rounded-lg p-4 transition-all duration-200 ease-in-out cursor-pointer hover:shadow-md",
              isChecked
                ? "border-primary-500 border-2 shadow-sm"
                : "border-alpha-100 shadow-xs border"
            )}
          >
            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => onToggle(opt)}
                className="shrink-0 h-4 w-4 rounded border-content-100 text-primary-500 focus:ring-0 focus:ring-offset-0"
              />
              <span className="text-alpha-900 text-base font-bold">{opt}</span>
            </div>
          </label>
        );
      })}
    </div>
  );
};
